

export class UpdateTicket 
{
    status : number; 
    details:string; 
    resolution : string;
    dateresolved : Date;
    assigned_to : number;
}